const cssVersionMap = {
  airFareRules: '3.1.3',
  dataCollector: '4.1.4',
  datesPicker: '6.1.4',
  declarativeCard: '3.99.0', // match vac-client version
  errorView: '2.7.16', // should this match paymentWidget version?
  fareRules: '3.0.3',
  flightRefund: '3.0.3',
  flightsChange: '5.0.4', // match @vac/rich-cards-flights-date-change
  flightScheduleChange: '3.0.3',
  paymentWidget: '5.0.5',
  penalty: '3.0.3',
  pnr: '3.0.3',
  refundTracker: '3.0.3',
  rewardsTracker: '3.0.3',
  termsAndConditions: '3.0.3',
};

module.exports = cssVersionMap;
